import React from "react";
import GitHubCalendar from "react-github-calendar";
import { useLanguage } from "../../context/LanguageContext";

const githubTheme = {
  level0: "#ebedf0",
  level1: "#9be9a8",
  level2: "#40c463",
  level3: "#30a14e",
  level4: "#216e39",
};

function Github() {
  const { t } = useLanguage();

  return (
    <section className="github-activity">
      <h1 className="project-heading">
        {t("about.code")}
      </h1>

      <div className="github-calendar-card">
        <div className="github-calendar-meta">
          <span className="github-live-label">
            <span aria-hidden="true" />
            {t("about.githubActivity")}
          </span>
          <strong>@zainalsalamun</strong>
        </div>

        <a
          className="github-calendar-link"
          href="https://github.com/zainalsalamun"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="github-calendar-scroll">
            <GitHubCalendar
              username="zainalsalamun"
              blockSize={15}
              blockMargin={5}
              fontSize={16}
              theme={githubTheme}
              labels={{ totalCount: t("about.contributions") }}
            />
          </div>

          <span className="github-profile-link">
            {t("about.github")} <i className="fa fa-arrow-right" />
          </span>
        </a>
      </div>
    </section>
  );
}

export default Github;
